export default __webpack_public_path__ + "static/media/triangle.c539e7f8.svg";